export default __webpack_public_path__ + "static/media/fourJokers.41fb46cd.jpg";